export interface QuoteRequestData {
  accountNumber: string
  branchId?: string
  productId: number
  quantity: number
  name: string
  email: string
  phone: string
  notes?: string
}

export enum QuoteModalType {
  OFFER = 'OFFER',
  ENQUIRY = 'ENQUIRY',
  QUOTE_CART = 'QUOTE_CART',
  QUOTE_SINGLE = 'QUOTE_SINGLE',
}
